import styled from 'styled-components'

export const TermosContainer = styled.div`
  max-width: 900px;
  overflow: hidden;

  @media (max-height: 800px) {
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;
  }

  @media (max-width: 768px) {
    max-width: 700px;
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;

    display: flex;
    flex-direction: column;
    padding: 10px;

    p,
    strong {
      font-size: 14px;
      margin-bottom: 10px;
    }

    h4 {
      font-size: 20px;
      margin: 0;
    }
  }

  @media (max-width: 425px) {
    h4 {
      text-align: center;
    }
  }
`

export const ConteudoTermos = styled.div`
  height: 550px;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 15px;

  @media (max-height: 800px) {
    height: 400px;
  }

  @media (max-height: 600px) {
    height: 300px;
  }

  @media (max-width: 1279px) {
    height: 400px;
  }

  @media (max-width: 768px) {
    overflow: hidden;
    margin-bottom: 20px;
    height: 400px;
    min-height: 400px;
  }

  @media (max-width: 768px) and (max-height: 700px) {
    height: 300px;
    min-height: 300px;
  }
`

export const BotoesContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 5px;

  @media (max-width: 1279px) {
    margin-top: 15px;
    gap: 8px;
  }

  @media (max-width: 768px) {
    margin-top: 10px;
    flex-wrap: wrap;
  }
`

export const AceitarTermos = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  margin-top: 20px;

  .mantine-Checkbox-input {
    border-color: #4f6275 !important;
  }

  .mantine-Checkbox-label {
    color: #000 !important;
  }

  @media (max-width: 1279px) {
    margin-top: 15px;
  }

  @media (max-width: 768px) {
    flex-shrink: 0;
    margin-top: 10px;

    .mantine-Checkbox-label {
      font-size: 14px !important;
    }
  }

  @media (max-width: 480px) {
    .mantine-Checkbox-label {
      font-size: 14px !important;
    }
  }
`
